import {
  EkycTypes,
  UUIDType,
  ServiceTypes,
  PersonInfoType,
  RegisterServiceType,
  LocationType,
  BranchType,
  BrokerType,
  BranchParamsType,
  FaceVideoTypes,
  FaceVideoDataTypes,
  RequestOTPType,
  VerifyOTPType,
  StepDataType,
  EkycBackUploadTypes,
  EkycFrontUploadTypes,
} from './types';

import axiosInstance from 'services/common/instance';

const generateUUIDService = async (
  params: EkycTypes,
): Promise<UUIDType> => {
  const res = await axiosInstance.post('ekyc-open-account/generate-uuid', params);
  return res.data.data;
};

export const generalInfoPostService = async (
  params: EkycTypes,
): Promise<void> => {
  await axiosInstance.post('ekyc-open-account/general-info', params);
};

export const contactInfoPostService = async (
  params: EkycTypes,
): Promise<void> => {
  await axiosInstance.post('ekyc-open-account/contact-info', params);
};

export const getServiceListService = async (): Promise<ServiceTypes[]> => {
  const res = await axiosInstance.get('ekyc-service-packs');
  return res.data.data;
};
export const faceVideoPostService = async (
  params: FaceVideoTypes,
): Promise<FaceVideoDataTypes> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  formData.append('video', params.video);
  const res = await axiosInstance.post('ekyc-open-account/face-video', formData);
  return res.data.data;
};

export const checkFrontCardService = async (
  params: EkycFrontUploadTypes,
): Promise<void> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  formData.append('image', params.image);
  formData.append('customer_type', params.customer_type);
  await axiosInstance.post('ekyc-open-account/front-id-card', formData);
};

export const checkBackCardService = async (
  params: EkycBackUploadTypes,
): Promise<void> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  formData.append('image', params.image);
  await axiosInstance.post('ekyc-open-account/back-id-card', formData);
};

export const checkSignatureService = async (
  params: EkycBackUploadTypes,
): Promise<void> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  formData.append('image', params.image);
  await axiosInstance.post('ekyc-open-account/upload-signature', formData);
};

export const personInfoService = async (
  params: PersonInfoType,
): Promise<UUIDType> => {
  const res = await axiosInstance.post('ekyc-open-account/personal-info', params);
  return res.data.data;
};

export const registerServicePostService = async (
  params: RegisterServiceType,
): Promise<void> => {
  await axiosInstance.post('ekyc-open-account/register-service', params);
};

export const getLocationService = async (): Promise<LocationType[]> => {
  const res = await axiosInstance.get('ekyc-locations');
  return res.data.data;
};

export const getBranchByLocationService = async (
  params: BranchParamsType,
): Promise<BranchType[]> => {
  const res = await axiosInstance.get('ekyc-branches', { params });
  return res.data.data;
};

export const getBrokerByLocationService = async (
  params: BranchParamsType,
): Promise<BrokerType[]> => {
  const res = await axiosInstance.get('ekyc-brokers', { params });
  return res.data.data;
};

export const requestOTPService = async (
  params: RequestOTPType,
): Promise<void> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  await axiosInstance.post('ekyc-open-account/request-otp', formData);
};

export const resendOTPService = async (
  params: RequestOTPType,
): Promise<void> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  await axiosInstance.post('ekyc-open-account/resend-otp', formData);
};

export const verifyOTPService = async (
  params: VerifyOTPType,
): Promise<void> => {
  const formData = new FormData();
  formData.append('grecaptcha_token', params.grecaptcha_token);
  formData.append('uuid', params.uuid);
  formData.append('otp', params.otp);
  await axiosInstance.post('ekyc-open-account/verify-otp', formData);
};

export const getStepService = async (
  uuid: string,
): Promise<StepDataType> => {
  const res = await axiosInstance.get(`ekyc-open-account/steps/${uuid}`);
  return res.data.data;
};

export default generateUUIDService;
